import { render, staticRenderFns } from "./InsertConcept.vue?vue&type=template&id=9929a848&scoped=true"
import script from "./InsertConcept.vue?vue&type=script&lang=js"
export * from "./InsertConcept.vue?vue&type=script&lang=js"
import style0 from "./InsertConcept.vue?vue&type=style&index=0&id=9929a848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9929a848",
  null
  
)

export default component.exports